import type { SbReactComponentsMap } from '@storyblok/react';

import { BoardMember } from '../components/storyblok/BoardMember';
import { BoardSection } from '../components/storyblok/BoardSection';
import { Button } from '../components/storyblok/Button';
import { Callout } from '../components/storyblok/Callout';
import { CardGrid } from '../components/storyblok/CardGrid';
import { EventList } from '../components/storyblok/EventList';
import { Footer } from '../components/storyblok/Footer';
import { FooterColumn } from '../components/storyblok/FooterColumn';
import { FooterLink } from '../components/storyblok/FooterLink';
import { Header } from '../components/storyblok/Header';
import { Hero } from '../components/storyblok/Hero';
import { ImageContent } from '../components/storyblok/ImageContent';
import { Intersection } from '../components/storyblok/Intersection';
import { LinkedinContact } from '../components/storyblok/LinkedinContact';
import { MediaText } from '../components/storyblok/MediaText';
import { MemberCard } from '../components/storyblok/MemberCard';
import { MembersBlock } from '../components/storyblok/MembersBlock';
import { Page } from '../components/storyblok/Page';
import { PillarCard } from '../components/storyblok/PillarCard';
import { ProfileCard } from '../components/storyblok/ProfileCard';
import { RichText } from '../components/storyblok/RichText';
import { ServiceLink } from '../components/storyblok/ServiceLink';
import { SocialLink } from '../components/storyblok/SocialLink';

// Single registry mapping Storyblok blok component names → React components.
// This is the only place new blocks need to be registered. The map keys must
// match the lowercase `component` field authored in Storyblok.
export const components: SbReactComponentsMap = {
  board_member: BoardMember,
  board_section: BoardSection,
  button: Button,
  callout: Callout,
  card_grid: CardGrid,
  event_list: EventList,
  footer: Footer,
  footer_column: FooterColumn,
  footer_link: FooterLink,
  header: Header,
  hero: Hero,
  image_content: ImageContent,
  intersection: Intersection,
  linkedin_contact: LinkedinContact,
  media_text: MediaText,
  member_card: MemberCard,
  members_block: MembersBlock,
  page: Page,
  pillar_card: PillarCard,
  profile_card: ProfileCard,
  rich_text: RichText,
  service_link: ServiceLink,
  social_link: SocialLink,
};
